import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
const api = axiosInstance;
export default function OrderRemainingPayment() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [paying, setPaying] = useState(false);

  const canceled = searchParams.get("canceled");

  useEffect(() => {
    const loadOrder = async () => {
      try {
        console.log("🔵 Calling backend:", `/orders/by-token/${token}`);

        const res = await api.get(`/api/orders/by-token/${token}`);

        setOrder(res.data.order);
      } catch (err) {
        console.error("Failed to load order:", err);
      } finally {
        setLoading(false);
      }
    };

    loadOrder();
  }, [token]);

  if (loading) {
    return (
      <div className="p-6 text-center text-gray-600 text-lg">
        Loading order…
      </div>
    );
  }

  if (!order) {
    return (
      <div className="p-6 text-center text-red-600 text-lg">
        Order not found.
      </div>
    );
  }

  const alreadyPaid = Number(order.amountPaid || 0);
  const totalPrice = Number(order.price || 0);
  const remaining = totalPrice - alreadyPaid;

  const handlePayRemaining = async () => {
    try {
      setPaying(true);

      const res = await api.post(`/api/payments/order/${token}/remaining-checkout`);

      if (res.data.url) {
        window.location.href = res.data.url;
      }
    } catch (err) {
      console.error("Payment error:", err);
      setPaying(false);
      alert("Failed to start payment. Please try again.");
    }
  };

  return (
    <div className="max-w-xl mx-auto mt-10 bg-white p-6 rounded-xl shadow">
      <h1 className="text-2xl font-bold text-candy-primary mb-4 text-center">
        Pay Remaining Balance
      </h1>

      {canceled && (
        <p className="text-center text-red-500 mb-4">
          Payment was canceled — you can try again.
        </p>
      )}

      <div className="text-lg text-gray-700">
        <p className="mb-2">
          <strong>Order ID:</strong> {order.orderId}
        </p>
        <p className="mb-2">
          <strong>Total Price:</strong> ${totalPrice.toFixed(2)}
        </p>
        <p className="mb-2">
          <strong>Already Paid:</strong> ${alreadyPaid.toFixed(2)}
        </p>

        <p className="mt-4 text-xl font-semibold text-candy-primary">
          Remaining Balance: ${remaining.toFixed(2)}
        </p>
      </div>

      {remaining <= 0 ? (
        <p className="text-green-600 font-semibold text-center mt-6">
          🎉 Your order is fully paid!
        </p>
      ) : (
        <button
          onClick={handlePayRemaining}
          disabled={paying}
          className={`w-full py-3 mt-8 rounded-lg text-white font-semibold transition ${
            paying
              ? "bg-candy-primary/70 cursor-not-allowed"
              : "bg-candy-primary hover:bg-candy-primaryDark"
          }`}
        >
          {paying
            ? "Redirecting to Stripe…"
            : `Pay Remaining $${remaining.toFixed(2)}`}
        </button>
      )}
    </div>
  );
}
